export default {"src":"/_next/static/media/arrowGrey.19a4b464.svg","height":14,"width":8};